import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import api from "../lib/axios";
import { FeatureProvider } from "../lib/features";
import type { FeatureMap } from "../lib/features";


export default function Layout() {
  const [features, setFeatures] = useState<FeatureMap>({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/features");
        setFeatures(res.data ?? {});
      } catch (e) {
        // If this fails, default to "nothing paid is enabled"
        setFeatures({});
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  // Optional: gate rendering so Sidebar doesn't flicker paid items
  if (!loaded) {
    return <div className="min-h-screen bg-gray-100" />;
  }

  return (
    <FeatureProvider value={features}>
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </FeatureProvider>
  );
}
